import Button from '@ingka/button';
import Text from '@ingka/text';
import { useNavigate } from 'react-router';
import { signIn } from '@/api/client';
import AppFooter from '@/components/layout/AppFooter';
import AppHeader from '@/components/layout/AppHeader';
import styles from './LandingPage.module.css';

function HowItWorksCard({ n, title, body }: { n: number; title: string; body: string }) {
  return (
    <div className={styles.card}>
      <div className={styles.cardNumber}>{n}</div>
      <p className={styles.cardTitle}>{title}</p>
      <p className={styles.cardBody}>{body}</p>
    </div>
  );
}

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <AppHeader showArchive />
      <main className={styles.main}>
        <section className={styles.hero}>
          <div>
            <Text tagName="h1" textStyle="Display.L" className={styles.heroTitle}>
              Upload data files.
              <br />
              Quickly and safely.
            </Text>
            <Text tagName="p" textStyle="Body.L" className={styles.heroBody}>
              Send CMPDT and CMPPE data files into our systems. Pick the product, choose the entity,
              drop your file. We&rsquo;ll take care of the rest.
            </Text>
            <div className={styles.heroActions}>
              <Button type="emphasised" text="Sign in with SSO" onClick={() => signIn()} />
              <Button
                type="secondary"
                text="See file archive"
                onClick={() => navigate('/archive')}
              />
            </div>
          </div>
        </section>

        <section className={styles.howItWorks}>
          <div className={styles.howItWorksInner}>
            <Text tagName="h2" textStyle="Heading.L" className={styles.howItWorksTitle}>
              How it works
            </Text>
            <Text tagName="p" textStyle="Body.L" className={styles.howItWorksSubtitle}>
              Four steps. Everything tracked, everything searchable.
            </Text>
            <div className={styles.howItWorksGrid}>
              <HowItWorksCard
                n={1}
                title="Sign in"
                body="Use your corporate SSO. One click, no passwords to remember."
              />
              <HowItWorksCard
                n={2}
                title="Pick a product"
                body="Choose the product area — CMPDT or CMPPE."
              />
              <HowItWorksCard
                n={3}
                title="Choose entity"
                body="Tell us what's in the file. Each entity has its own expected schema and format."
              />
              <HowItWorksCard
                n={4}
                title="Select a classification"
                body="Choose the classification type for your data - private, confidential, or PII sensitive."
              />
              <HowItWorksCard
                n={5}
                title="Upload your file"
                body="Drag and drop, or browse. We validate, route, and confirm — usually within a second."
              />
            </div>
          </div>
        </section>
      </main>
      <AppFooter />
    </div>
  );
}
